var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClaimsManager(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20833 15C5.20833 14.6548 5.48816 14.375 5.83333 14.375H11.6667C12.0118 14.375 12.2917 14.6548 12.2917 15C12.2917 15.3452 12.0118 15.625 11.6667 15.625H5.83333C5.48816 15.625 5.20833 15.3452 5.20833 15Z",
    fill: "#4B5054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20833 11.6667C5.20833 11.3215 5.48816 11.0417 5.83333 11.0417H6.66667C7.01184 11.0417 7.29167 11.3215 7.29167 11.6667C7.29167 12.0118 7.01184 12.2917 6.66667 12.2917H5.83333C5.48816 12.2917 5.20833 12.0118 5.20833 11.6667Z",
    fill: "#4B5054"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20833 8.33332C5.20833 7.98815 5.48816 7.70832 5.83333 7.70832H8.33333C8.67851 7.70832 8.95833 7.98815 8.95833 8.33332C8.95833 8.6785 8.67851 8.95832 8.33333 8.95832H5.83333C5.48816 8.95832 5.20833 8.6785 5.20833 8.33332Z",
    fill: "#4B5054"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20833 1.66666C5.20833 1.32148 5.48816 1.04166 5.83333 1.04166H13.75C13.9158 1.04166 14.0747 1.1075 14.1919 1.22471L17.9419 4.97471C18.0592 5.09193 18.125 5.2509 18.125 5.41666V15.8333C18.125 16.1785 17.8452 16.4583 17.5 16.4583C17.1548 16.4583 16.875 16.1785 16.875 15.8333V5.67554L13.4911 2.29166H5.83333C5.48816 2.29166 5.20833 2.01183 5.20833 1.66666Z",
    fill: "#4B5054"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 4.79166C3.40482 4.79166 3.125 5.07148 3.125 5.41666V17.0833C3.125 17.4285 3.40482 17.7083 3.75 17.7083H13.75C14.0952 17.7083 14.375 17.4285 14.375 17.0833V7.34221L11.8244 4.79166H3.75ZM1.875 5.41666C1.875 4.38112 2.71447 3.54166 3.75 3.54166H11.8762C12.1746 3.54166 12.4607 3.66018 12.6717 3.87116L15.2955 6.49494C15.5065 6.70591 15.625 6.99206 15.625 7.29043V17.0833C15.625 18.1189 14.7855 18.9583 13.75 18.9583H3.75C2.71447 18.9583 1.875 18.1189 1.875 17.0833V5.41666Z",
    fill: "#4B5054"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6667 3.54166C12.0118 3.54166 12.2917 3.82148 12.2917 4.16666V6.87499H15C15.3452 6.87499 15.625 7.15481 15.625 7.49999C15.625 7.84517 15.3452 8.12499 15 8.12499H12.1667C11.5453 8.12499 11.0417 7.62131 11.0417 6.99999V4.16666C11.0417 3.82148 11.3215 3.54166 11.6667 3.54166Z",
    fill: "#4B5054"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaimsManager);
export default __webpack_public_path__ + "static/media/claims-manager.6d1076154d7d79f941a2d14c7f92f0c6.svg";
export { ForwardRef as ReactComponent };